export default __webpack_public_path__ + "static/media/streamer_avatar15.fb9a700b.png";